import React from "react";
import middleware from "./middleware/middleware";
import AllManagePageSitePublisher from "../component/sections/page/manage/AllPageSitePublisher";
import ViewManagePageSitePublisher from "../component/sections/page/manage/ViewPageSitePublisher";

const sitesRoutes = [
  {
    path: "/page/manage/all/publisher/:publisherID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllManagePageSitePublisher />,
        "AllManagePageSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/page/manage/:pageID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewManagePageSitePublisher />,
        "ViewManagePageSitePublisher"
      );
    },
    exact: true,
  },
];

export default sitesRoutes;
